const isSandbox = process.env.REACT_APP_DOCS_ENV === "sandbox";

export const DOMAIN = isSandbox ? "remotepass.dev" : "remotepass.com";

export const DOMAIN_TOKEN = "{{DOMAIN}}";
